import * as React from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
  max-width: 75vw;
  font-size: 0.8rem;
`;
const Pill = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 0.3rem;
    line-height: 1;
    border-radius: 15px;
    padding: 5px 10px;
    background-color: ${theme.colors.background.secondaryNav};
  `
);
const RemoveFilter = styled(Icon)(
  ({ theme }) => css`
    padding-left: 5px;
    cursor: pointer;
    color: ${theme.colors.text.secondary};

    &:hover {
      color: ${theme.colors.text.severity.danger};
    }
  `
);
const FiltersRow = ({ filters, labels = {}, onRemove }) => {
  const isDate = (value) => new Date(value).toString() !== "Invalid Date" && !!value.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/);
  const toLabel = (text) => text.replace(/(\w?)|(_\w?)/, (char) => char.toUpperCase()).replaceAll("_", " ");
  const filteredObj = Object.fromEntries(
    Object.keys(filters).filter((key) => key !== "alerts" && key !== "timerange").map((key) => [key, filters[key]])
  );
  return /* @__PURE__ */ React.createElement(Row, null, Object.entries(filteredObj).map(([column, fData], i) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `filter-${column}` }, i > 0 ? /* @__PURE__ */ React.createElement("i", null, "and") : null, /* @__PURE__ */ React.createElement(Pill, null, /* @__PURE__ */ React.createElement("b", null, labels[column] ? labels[column] : toLabel(column), ":"), " ", fData.map((data, j) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `fvalue-${data.label}` }, j > 0 ? /* @__PURE__ */ React.createElement("i", null, isDate(data.label) ? "to" : "or") : null, /* @__PURE__ */ React.createElement("span", null, data.label))), " ", /* @__PURE__ */ React.createElement(RemoveFilter, { name: "close", size: "xs", onClick: onRemove(column) })))));
};
export default FiltersRow;
